import { addItemToBasket, BASKET_TYPES, extendFormToMap } from 'containers/OrderDetails/basketSlice'
import { selectPlaceData } from 'containers/MapDetails/placeSlice'
import { useReduxDispatch, useReduxSelector } from 'store'
import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import type { WarehouseGroup } from './Summary'
import { useHistory } from 'react-router-dom'
import { displayPrice } from 'utils/string'
import React, { useState } from 'react'
import { v7 } from 'uuid'

interface ListItemProps extends WarehouseGroup {
  isSelected?: boolean
  hash: string
}

const ListItem: React.FC<ListItemProps> = ({ isSelected = false, hash, name, data, attrs, warehousesInfo, for_rent, isAvailableForRentNow, warehouseTypeName }) => {
  const [isExpanded, expand] = useState(isSelected)
  const place = useReduxSelector(selectPlaceData)

  const forRentDates = Object.values(for_rent || {})

  const { push } = useHistory()
  const dispatch = useReduxDispatch()
  const { t } = useTranslation('placeMap')

  const addToBasket = (date: null | string, id?: string) => {
    const identifier = v7()
    const { street, estateNumber, localNumber, city, province, gpslatitude, gpslongitude } = place

    dispatch(
      addItemToBasket({
        id,
        hash,
        identifier,
        type: BASKET_TYPES.rent,
        object: data?.object,
        address: { street, estateNumber, localNumber, city, province, gpslatitude, gpslongitude },
        minDate: date ? date.replace(/(\d{2})\.(\d{2})\.(\d{4})/, '$3-$2-$1') : undefined,
        size: {
          internalHeight: data.internalHeight,
          internalLength: data.internalLength,
          internalWidth: data.internalWidth,
          area: data.area
        },
        name: warehouseTypeName,
        hasOnlineAccess: data.hasOnlineAccess,
        place: place.id,
      })
    )
    push(`/order/${identifier}`)
    dispatch(extendFormToMap(false))
  }

  return (
    <div className='placeMap__list__item'>
      <div
        className='placeMap__list__item__top group'
        onClick={() => {
          expand(e => !e)
        }}>
        <div>
          <div className='placeMap__list__item__title --secFont'>
            <span>{name}</span>
          </div>
          <div className='placeMap__list__item__attributes'>
            {attrs.map(({ key, name }) => <div
              key={key}
              className='placeMap__list__item__attribute'>
              <i className={`icon icon--${key}-bold`} />
              <span>{name}</span>
            </div>)}
          </div>
        </div>
        <div className='center --gap1'>
          <div className='placeMap__list__item__price'>
            <div>{displayPrice(data.monthlyGrossPrice)}</div>
            <div>{t('monthly')}</div>
          </div>
          {!place?.displayOptions?.listAllWarehouses && <ArrowBtn
            text={isAvailableForRentNow ? t('rent')
              : forRentDates.length > 0 ? `${t('rentFrom')} ${forRentDates[0]}`
                : t('inaccessible')}
            showArrow={isAvailableForRentNow || forRentDates.length > 0}
            disabled={!isAvailableForRentNow && forRentDates.length === 0}
            action={() => {
              if (isAvailableForRentNow || forRentDates.length > 0) {
                addToBasket(isAvailableForRentNow ? null : forRentDates[0])
              }
            }} />}
        </div>
      </div>
      {warehousesInfo && place?.displayOptions?.listAllWarehouses && <div className={`hidableElement${isExpanded ? '' : ' --hidden'}`}>
        <div>
          <div className='placeMap__list__bottomList'>
            {Object.entries(warehousesInfo).map(([id, { number }]) => {
              const isDisabled = for_rent?.[id] === undefined
              return <div
                key={id}
                className='placeMap__list__bottomList__item group'>
                <div className='placeMap__list__item__title --secFont'>
                  <span>{t('warehouseNo')} {number}</span>
                </div>
                <ArrowBtn
                  text={isDisabled ? t('inaccessible')
                    : for_rent?.[id] === null ? t('rent')
                      : `${t('rentFrom')} ${for_rent?.[id]}`}
                  showArrow={!isDisabled}
                  disabled={isDisabled}
                  action={() => {
                    addToBasket(for_rent?.[id], id)
                  }} />
              </div>
            })}
          </div>
        </div>
      </div>}
    </div>
  )
}

export default ListItem